import { Component } from '@angular/core';

@Component({
  selector: 'app-blog-single',
  templateUrl: './blog-single.component.html'
})
export class BlogSingleComponent {}
